webpackJsonp([70144966829960],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HowdyForm = function (_Component) {
	  _inherits(HowdyForm, _Component);
	
	  function HowdyForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HowdyForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._injectScript = function () {
	      var script = document.createElement('script');
	      script.src = 'https://static.howdyform.com/howdyClient.js?token=' + _this.props.token;
	      script.async = true;
	      script.id = 'howdyScript' + _this.props.token;
	      script.dataset.howdyRecipient = _this.props.email;
	      if (_this.props.onSubmit) {
	        script.onload = function () {
	          window.howdyEvents.afterSend = _this.props.onSubmit;
	        };
	      }
	      document.body.appendChild(script);
	    }, _this._updateScript = function () {
	      document.getElementById('howdyScript' + _this.props.token).remove();
	      _this._injectScript();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HowdyForm.prototype.componentDidMount = function componentDidMount() {
	    if (!window.howdyEvents) this._injectScript();
	  };
	
	  HowdyForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.email !== this.props.email || nextProps.token !== this.props.token || nextProps.onSubmit !== this.props.onSubmit) this._updateScript();
	  };
	
	  HowdyForm.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        email = _props.email,
	        onSubmit = _props.onSubmit,
	        token = _props.token,
	        rest = _objectWithoutProperties(_props, ['children', 'email', 'onSubmit', 'token']);
	
	    return _react2.default.createElement(
	      'form',
	      rest,
	      children
	    );
	  };
	
	  return HowdyForm;
	}(_react.Component);
	
	exports.default = HowdyForm;
	
	
	HowdyForm.propTypes = {
	  email: _propTypes2.default.string.isRequired,
	  token: _propTypes2.default.string.isRequired,
	  onSubmit: _propTypes2.default.func
	};
	module.exports = exports['default'];

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var id = _ref.id,
	      label = _ref.label,
	      multiline = _ref.multiline,
	      _ref$hideLabel = _ref.hideLabel,
	      hideLabel = _ref$hideLabel === undefined ? false : _ref$hideLabel,
	      rest = _objectWithoutProperties(_ref, ['id', 'label', 'multiline', 'hideLabel']);
	
	  var Element = multiline ? 'textarea' : 'input';
	  return _react2.default.createElement(
	    'div',
	    { className: 'labelled-input' },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: id, className: hideLabel ? 'sr-only' : '' },
	      label
	    ),
	    _react2.default.createElement(Element, _extends({
	      className: 'input',
	      id: id,
	      rows: multiline ? 2 : undefined
	    }, rest))
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _HowdyForm = __webpack_require__(199);
	
	var _HowdyForm2 = _interopRequireDefault(_HowdyForm);
	
	var _LabelledInput = __webpack_require__(200);
	
	var _LabelledInput2 = _interopRequireDefault(_LabelledInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONTACT_EMAIL = 'joe@keyvaluedevelopment.co.uk';
	var HOWDY_TOKEN = 'am9lQGtleXZhbHVlZGV2ZWxvcG1lbnQuY28udWs';
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'contact-page' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      'back'
	    ),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Contact us'
	    ),
	    _react2.default.createElement(
	      _HowdyForm2.default,
	      {
	        token: HOWDY_TOKEN,
	        email: CONTACT_EMAIL,
	        onSubmit: function onSubmit() {
	          return (0, _gatsbyLink.navigateTo)('/cheers');
	        }
	      },
	      _react2.default.createElement(_LabelledInput2.default, { name: 'name', label: 'Name', id: 'name' }),
	      _react2.default.createElement(_LabelledInput2.default, { name: 'email', type: 'email', label: 'Email', id: 'email' }),
	      _react2.default.createElement(_LabelledInput2.default, { name: 'message', multiline: true, label: 'Message', id: 'message' }),
	      _react2.default.createElement(
	        'button',
	        { type: 'submit', style: { float: 'right' } },
	        'Send'
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-0fe2023b7f9d7b987aea.js